// ONE DOOR for a professional's public address (Founder 06/10/26: "תמיד, ה-URL של בעל עסק הוא רק המספר שלו": experts.co.il/4139).
// Every link, sitemap entry, canonical, redirect, admin link and outreach message that points at a pro page is built HERE —
// never from category_slug + slug (those long URLs now 301 to this one, app/[catSlug]/[proSlug]/page.tsx).
export const SITE_ORIGIN = "https://experts.co.il";
/** Site-relative path: /4139 */
export const proPath = (id) => "/" + Number(id);
/** Absolute canonical URL: https://experts.co.il/4139 */
export const proUrl = (id) => SITE_ORIGIN + proPath(id);
